import { render, staticRenderFns } from "./folders-ports-countries-options-berth-list.vue?vue&type=template&id=120952fa&scoped=true"
import script from "./folders-ports-countries-options-berth-list.vue?vue&type=script&lang=js"
export * from "./folders-ports-countries-options-berth-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120952fa",
  null
  
)

export default component.exports